import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { NotificationProvider } from './components/NotificationSystem'
import { DemoProvider } from './components/DemoProvider'
import { WalletProvider } from './components/WalletProvider'
import App from './App'
import './styles/global.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <NotificationProvider>
        <DemoProvider>
          <WalletProvider>
            <App />
          </WalletProvider>
        </DemoProvider>
      </NotificationProvider>
    </BrowserRouter>
  </React.StrictMode>
)
